import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { formatVal } from '../../../helpers/value'
import { BOARD_COL_IDS } from '../constant'
import {
  selectCompanyBoardOfManagementById,
  selectCompanyInfoDetail,
} from '../store/slice'

export const Management = ({ isDynamicReport }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const rowIds = useSelector(
    selectCompanyInfoDetail((detailData) => {
      const data = detailData.companyBoardOfManagement
      if (!data) return []
      return data.map((item) => item.personId)
    }),
  )

  return (
    <Element>
      <Table
        ids={rowIds}
        getDataFromRedux={selectCompanyBoardOfManagementById}
        schema={Object.keys(BOARD_COL_IDS).map((key, index) => {
          const colId = BOARD_COL_IDS[key]
          const isSttCol = colId === BOARD_COL_IDS.STT
          return {
            colId,
            title: isSttCol ? '#' : 'companyProfile.' + key,
            isI18n: true,
            thStyle: {
              justifyContent:
                colId === BOARD_COL_IDS.SHAREHOLDING ? 'flex-end' : '',
            },
            tdStyle: {
              textAlign:
                colId === BOARD_COL_IDS.SHAREHOLDING ? 'right' : 'left',
            },
            render: (data, { rowIndex }) => {
              switch (colId) {
                case BOARD_COL_IDS.STT:
                  return rowIndex + 1
                case BOARD_COL_IDS.SHAREHOLDING:
                  return formatVal(data * 100, locale) + '%'
                default:
                  return data
              }
            },
          }
        })}
        noDataText="companyProfile.NO_MANAGEMENT_DATA"
        autoHeightMax={1000}
        isDynamicReport={isDynamicReport}
      />
    </Element>
  )
}
